import { Avatar, SxProps, Theme } from '@mui/material';
import { CheckboxChecked, CheckboxError, CheckboxUnchecked } from 'Images';

const CHECKBOX_ICON_SIZE = '21px';

interface ICheckboxIconProps {
  sx?: SxProps<Theme>;
}

export const CheckboxUncheckedIcon = ({ sx }: ICheckboxIconProps) => (
  <Avatar
    alt=''
    src={CheckboxUnchecked}
    sx={{ width: CHECKBOX_ICON_SIZE, height: CHECKBOX_ICON_SIZE, ...sx }}
  />
);

export const CheckboxCheckedIcon = ({ sx }: ICheckboxIconProps) => (
  <Avatar
    alt=''
    src={CheckboxChecked}
    sx={{ width: CHECKBOX_ICON_SIZE, height: CHECKBOX_ICON_SIZE, ...sx }}
  />
);

export const CheckboxErrorIcon = ({ sx }: ICheckboxIconProps) => (
  <Avatar
    alt=''
    src={CheckboxError}
    sx={{ width: CHECKBOX_ICON_SIZE, height: CHECKBOX_ICON_SIZE, ...sx }}
  />
);

export const checkboxIconProps = (isError = false) => ({
  icon: isError ? <CheckboxErrorIcon /> : <CheckboxUncheckedIcon />,
  checkedIcon: <CheckboxCheckedIcon />,
});
